import { IonInfiniteScrollCustomEvent } from '@ionic/core'
import { IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { observer } from 'mobx-react'
import React from 'react'
import { BaseListParams } from '../../store/subStore'

type InfinityContentProps = {
  listParams?: BaseListParams
  onScroll: (ev: IonInfiniteScrollCustomEvent<void>) => void
  reverse?: boolean
}

export const InfinityContent: React.FC<InfinityContentProps> = observer(({ listParams, onScroll, reverse }) => {
  if (listParams?.last) {
    return <></>
  }
  return (
    <>
      {!reverse ? (
        <IonInfiniteScroll
          onIonInfinite={(ev) => {
            onScroll != null && onScroll(ev)
            setTimeout(() => ev.target.complete(), 100)
          }}
        >
          <IonInfiniteScrollContent />
        </IonInfiniteScroll>
      ) : (
        <IonInfiniteScroll
          onIonInfinite={(ev) => {
            onScroll != null && onScroll(ev)
            ev.target.complete()
          }}
          position={'top'}
        >
          <IonInfiniteScrollContent />
        </IonInfiniteScroll>
      )}
    </>
  )
})
